import type { ContentWatchedCommand } from '~/features/content-watched/index.h'
import type { RemoveFromContinueWatchingRoute } from '~/features/remove-from-continue-watching/index.h'

import { MediaTypes } from '@setplex/tria-api'

export type ContinueWatchingStructureItem = {
  contentId?: number
  contentType?: string
  tvShowId?: number
  seasonId?: number
  isWithSeason?: boolean
}

export const matchesContinueWatchingRemoveRoute = (
  item: ContinueWatchingStructureItem,
  route: RemoveFromContinueWatchingRoute
): boolean => {
  if (route.type === 'vod') {
    return item.contentType === MediaTypes.VOD && item.contentId === route.vodId
  }

  if (item.contentType !== MediaTypes.EPISODE) {
    return false
  }

  if (!item.tvShowId) {
    return false
  }

  if (route.type === 'episodeWithSeason') {
    return (
      item.contentId === route.episodeId &&
      item.tvShowId === route.tvShowId &&
      item.seasonId === route.seasonId &&
      item.isWithSeason === true
    )
  }

  return (
    item.contentId === route.episodeId &&
    item.tvShowId === route.tvShowId &&
    item.isWithSeason !== true
  )
}

export const matchesContentWatchedCommand = (
  item: ContinueWatchingStructureItem,
  command: ContentWatchedCommand
): boolean => {
  if (command.type === 'vod') {
    return item.contentType === MediaTypes.VOD && item.contentId === command.id
  }

  if (item.contentType !== MediaTypes.EPISODE) {
    return false
  }

  if (!item.tvShowId) {
    return false
  }

  if (command.type === 'episodeWithSeason') {
    return (
      item.contentId === command.episodeId &&
      item.tvShowId === command.tvShowId &&
      item.seasonId === command.seasonId &&
      item.isWithSeason === true
    )
  }

  return (
    item.contentId === command.episodeId &&
    item.tvShowId === command.tvShowId &&
    item.isWithSeason !== true
  )
}
